import axios, { AxiosResponse } from "axios";
import AccuracyDate from "@/models/AccuracyDate";
import { getTsQueryValue } from "@/utils/common";

export default class Event {
  id: number | null = null;
  serial_no: string = "";
  name: string = "";
  year: number | null = null;
  displacement_type: string = "";
  hazard_type_id: number | null = null;
  comment: string = "";
  start_date: AccuracyDate = { date: "", accuracy: "Day" };
  end_date: AccuracyDate = { date: "", accuracy: "Day" };
  glide_numbers: string[] = [];
  created_by: string | null = null;
  created_at: string | null = null;
  updated_by: string | null = null;
  updated_at: string | null = null;
  gsn: string | null = null;
  data_included: boolean = true;
}

export function getEventByID(id: number, isClone: boolean = false) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!id) throw new Error("Event id is required");
      let response = await axios.get("/psql/events", {
        params: { id: `eq.${id}` },
        headers: { Accept: "application/vnd.pgrst.object+json" },
      });
      const event = response.data;
      if (isClone) {
        delete event.id;
        delete event.serial_no;
        delete event.created_at;
        delete event.created_by;
        delete event.gsn;
      }
      resolve(event);
    } catch (error) {
      reject(error);
    }
  });
}

export function createEvent(event: Event) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!event) throw new Error("Event can't be saved");
      let option: any = {
        headers: {
          Accept: "application/vnd.pgrst.object+json",
          Prefer: "return=representation",
        },
      };
      delete event.id;
      delete event.serial_no;
      delete event.created_at;
      delete event.created_by;
      delete event.gsn;
      let response = await axios.post("/psql/events", event, option);
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
}

export function updateEvent(event: Event) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!event || !event.id) throw new Error("Event can't be saved");
      let option: any = {
        params: { id: `eq.${event.id}` },
        headers: {
          Accept: "application/vnd.pgrst.object+json",
          Prefer: "return=representation",
        },
      };
      let response = await axios.patch("/psql/events", event, option);
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
}

export function deleteEventByID(id: number) {
  return new Promise(async (resolve, reject) => {
    try {
      if (!id) {
        throw new Error("Event id is required");
      }
      let response = await axios.delete("/psql/events", { params: { id: `eq.${id}` } });
      resolve(response);
    } catch (error) {
      reject(error);
    }
  });
}

export function getEventByPhrase(phrase: string) {
  return axios.get(`/psql/events_view`, {
    params: {
      select: "id,name",
      name: getTsQueryValue(phrase),
      order: "created_at.desc",
    },
  });
}
